import { ApiMethod } from 'services/api';
import { useRestQuery, useRestMutation, UseRestMutationOptions } from 'utils/hooks/api';

export const FETCH_MEMBERS = '/i/organizations/members';
export const RESET_MFA_FOR_MEMBER = '/resetMfaForMember';

export const useMembersQuery = () => useRestQuery(FETCH_MEMBERS);

export const useResetMfaForMember = (options?: UseRestMutationOptions) =>
  useRestMutation(RESET_MFA_FOR_MEMBER, ApiMethod.post, options);

export type ProjectMemberships = {
  projectId: number;
  roleId: number;
};

export type TeamMemberships = {
  projectId: number;
  roleId: number;
  teamId: number;
};
export type Member = {
  createdAt: number;
  createdBy: string;
  email: string;
  firstName: string;
  lastName: string;
  orgAdmin: boolean;
  organizationPermissions: number[];
  projectMemberships: ProjectMemberships[];
  teamMemberships: TeamMemberships[];
  tfa: boolean;
  updatedAt: number;
  userId: string;
};
